import {
  AccountCircle,
  Lock,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import {
  Alert,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Container,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  Snackbar,
  TextField,
} from "@mui/material";
import { observer } from "mobx-react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppContainer from "src/components/AppContainer";
import { useStore } from "src/providers/store";
import css from "./login.module.scss";

const LoginPage = () => {
  const { admin } = useStore();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbar, setSnackbar] = useState({
    severity: "success",
    message: "",
  });

  const onChangeUsername = (event) => {
    setUsername(event.target.value);
  };
  function onChangePassword(event) {
    setPassword(event.target.value);
  }
  function validateForm() {
    return username.length > 0 && password.length > 0;
  }

  const onSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      const response = await admin.login(username, password);
      if (response) {
        navigate("/admin-list");
      } else {
        event.preventDefault();
        setSnackbar({ severity: "error", message: "ล็อคอินไม่สำเร็จ" });
        setOpenSnackbar(true);
      }
    }
    event.preventDefault();
  };

  const handleCloseSnackbar = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  useEffect(() => {}, []);

  return (
    <AppContainer className={css.appContainer}>
      <Container className={css.container}>
        <form onSubmit={onSubmit}>
          <Card sx={{ minWidth: 300, padding: "0" }} className={css.card}>
            <CardHeader title={t("loginPage.title")}></CardHeader>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormLabel>{t("loginPage.detail")}</FormLabel>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="username"
                    variant="outlined"
                    placeholder={t("loginPage.username")}
                    fullWidth
                    required
                    value={username}
                    onChange={onChangeUsername}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AccountCircle />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="password"
                    variant="outlined"
                    placeholder={t("loginPage.password")}
                    type={showPassword ? "text" : "password"}
                    fullWidth
                    required
                    value={password}
                    onChange={onChangePassword}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Lock />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={rememberMe}
                        onChange={() => setRememberMe(!rememberMe)}
                        name={t<string>("loginPage.rememberMe")}
                      />
                    }
                    label={t<string>("loginPage.rememberMe")}
                  />
                </Grid>
              </Grid>
            </CardContent>
            <CardActions className={css.cardAction}>
              <Button onClick={() => navigate("/forgot-password")}>
                {t("loginPage.forgotPassword")}
              </Button>
              <Button type="submit" variant="contained" size="large">
                {t("loginPage.loginBtn")}
              </Button>
            </CardActions>
          </Card>
        </form>

        <Snackbar
          open={openSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          autoHideDuration={5000}
          onClose={handleCloseSnackbar}
        >
          <Alert
            onClose={handleCloseSnackbar}
            variant="filled"
            severity={snackbar.severity === "success" ? "success" : "error"}
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Container>
    </AppContainer>
  );
};
export default observer(LoginPage);
